/** Maps a console-api base URL to the Admin app in the same environment */
export const adminUrlFor = (consoleApiBaseUrl: string) =>
  consoleApiBaseUrl.replace(/\/\/console-api\./, '//admin.').replace(/\/$/, '')
